module.exports = __webpack_public_path__ + "img/uart3.43a7368c.png";